var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotelPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hotel",
    clipPath: "url(#clip0_1171_7927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.75 9.75C6.995 9.75 8 8.745 8 7.5C8 6.255 6.995 5.25 5.75 5.25C4.505 5.25 3.5 6.255 3.5 7.5C3.5 8.745 4.505 9.75 5.75 9.75ZM14.75 5.25H10.25C9.425 5.25 8.75 5.925 8.75 6.75V10.5H2.75V4.5C2.75 4.0875 2.4125 3.75 2 3.75C1.5875 3.75 1.25 4.0875 1.25 4.5V14.25C1.25 14.6625 1.5875 15 2 15C2.4125 15 2.75 14.6625 2.75 14.25V12.75H16.25V14.25C16.25 14.6625 16.5875 15 17 15C17.4125 15 17.75 14.6625 17.75 14.25V8.25C17.75 6.5925 16.4075 5.25 14.75 5.25Z",
    fill: "#344054"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1171_7927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelPackage);
export default __webpack_public_path__ + "static/media/hotel-package.b48539c100c92caee8ac46131be203d2.svg";
export { ForwardRef as ReactComponent };